import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F0F4F8] to-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1E5A8E] mb-8">
            Contact Us
          </h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Get in Touch
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  We're here to help and answer any questions you may have about RECOVER. 
                  We look forward to hearing from you.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Support Email
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  For all inquiries, including account deletion requests or other support needs, 
                  please contact us at:
                </p>
                <div className="bg-[#F0F4F8] rounded-lg p-6 mb-4">
                  <a 
                    href="mailto:admin@recoverapp.com.au" 
                    className="text-[#2F7FB7] hover:text-[#1E5A8E] font-semibold text-lg transition-colors"
                  >
                    admin@recoverapp.com.au
                  </a>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Account Deletion Requests
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  If you would like to delete your RECOVER account and associated data, 
                  please send an email to admin@recoverapp.com.au with the subject line 
                  "Account Deletion Request" and include:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2">
                  <li>Your registered email address</li>
                  <li>Your account username (if applicable)</li>
                  <li>Confirmation that you want to permanently delete your account</li>
                </ul>
                <p className="text-[#4A5568] leading-relaxed mt-4">
                  We will process your request within 30 days and send you a confirmation 
                  once your account and data have been deleted.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Other Inquiries
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  For general questions, technical support, feedback, or partnership opportunities, 
                  please reach out to us at the email address above. We aim to respond to all 
                  inquiries within 2-3 business days.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Privacy & Data Protection
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  Your privacy is important to us. For information about how we collect, use, 
                  and protect your personal information, please review our{' '}
                  <a href="/privacy-policy" className="text-[#2F7FB7] hover:text-[#1E5A8E] underline">
                    Privacy Policy
                  </a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  Crisis Support
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  If you are experiencing a mental health crisis or emergency, please contact 
                  emergency services immediately or reach out to a crisis helpline in your area:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2">
                  <li><strong>Australia:</strong> Lifeline 13 11 14 or Beyond Blue 1300 22 4636</li>
                  <li><strong>Emergency:</strong> 000 (Australia) or your local emergency number</li>
                </ul>
                <p className="text-[#4A5568] leading-relaxed mt-4">
                  RECOVER is a supportive tool for mental wellness but is not a substitute for 
                  professional medical advice, diagnosis, or treatment.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

